enum BusinessEntities {
    USA = 1,
    Netherlands = 2,
    Germany = 3,
    Manta = 4
}
export default BusinessEntities;